import { Selection } from '@recogito/annotorious/src/tools/Tool';
import { SVG_NAMESPACE } from '@recogito/annotorious/src/util/SVG';
import {
  createPathElement,
  getPathData,
  toFreehandTarget,
} from 'components/ImageViewer/annotorious/tools/freehand/freehandUtils';

/**
 * A 'rubberband' pencil: collects points while dragging and previews the
 * stroke as a polyline.
 */
export default class RubberbandFreehand {
  constructor(anchorX, anchorY, g, config, env) {
    this.env = env;
    this.config = config;
    this.points = [[anchorX, anchorY]];

    this.group = document.createElementNS(SVG_NAMESPACE, 'g');
    this.group.style.pointerEvents = 'none';

    this.path = createPathElement('a9s-selection');
    this.path.setAttribute('stroke', this.config?.lineColor || '#4CBFD4');
    this.path.setAttribute('stroke-width', 3);

    this.group.appendChild(this.path);
    g.appendChild(this.group);

    this.updatePreview();
  }

  addPoint(x, y) {
    const [lastX, lastY] = this.points[this.points.length - 1];

    // Drop near-duplicate points to keep the stored stroke lightweight.
    if (Math.hypot(x - lastX, y - lastY) < 1) {
      return;
    }

    this.points.push([x, y]);
    this.updatePreview();
  }

  updatePreview() {
    this.path.setAttribute('d', getPathData(this.points));
  }

  get element() {
    return this.path;
  }

  getPoints = () => this.points;

  toSelection = () =>
    new Selection(toFreehandTarget(this.points, this.env.image));

  destroy = () => {
    this.group.parentNode.removeChild(this.group);
    this.group = null;
    this.path = null;
    this.points = [];
  };
}
